// import darkModeDetect from '../js/helpers/darkModeDetect.js'
import dropDownNavigation from './modules/dropdown.js'
// import stickyNavigation from './modules/stickyNavigation.js'
import basicSlider from './modules/basicSlider.js'
import basicModal from  './modules/basicModal.js'

// Import our CSS
import '@/css/app.pcss';

/** Insert a line break before "Building" in footer address spans (fixes single-line wrapping). */
const formatAddressLineBreaks = (): void => {
    document.querySelectorAll<HTMLSpanElement>('span.block.address').forEach((span) => {
        let text = span.textContent?.replace(/\s+/g, ' ').trim() ?? '';
        text = text.replace(/\s*,\s*$/, '').trim();
        span.innerHTML = text.replace(/\s+Building\b/i, '<br>Building');
    });
};

// App main
const main = async () => {
    // darkModeDetect();
    dropDownNavigation();
    // stickyNavigation()
    // interactiveMap()
    basicSlider();
    basicModal();
    const { default: imageGallery } = await import('./modules/imageGallery.js');
    imageGallery();
};

// Run when DOM is ready (module scripts are deferred; this ensures nav exists)
const run = () => {
    formatAddressLineBreaks();
    main().then(async () => {
        const root = document.getElementById('page-container');
        if (root?.dataset.fidoCommercialMeasure === '1') {
            const { initFidoCommercialMeasurement } = await import(
                './modules/fidoCommercialMeasurement.js'
            );
            initFidoCommercialMeasurement();
        }
        console.log('[Fido app] loaded');
    });
};
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
    
} else {
    run();
}

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    });
}